import React from "react";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { Link } from 'react-router-dom';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";

// @material-ui/icons
import Close from "@material-ui/icons/Close";
import GridOnIcon from '@material-ui/icons/GridOn';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Search from "@material-ui/icons/Search";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import Style from "../../assets/jss/material-dashboard-pro-react/views/casesStyle";

import ExploreMap from "./ExploreMap";

// Firebase Redux Integration
import { startSetUsersList } from "store/actions/adminActions"
import CreateDocumentForm from "../../components/Forms/CreateDocumentForm";

const Transition = (props) => {
  return <Slide direction="down" {...props} />
}

class Explore extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newCaseModal: false,
      query: ''
    };
  }

  handleClose = (modal) => {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }

  handleSwitchChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  render() {
    const { classes, user, path } = this.props;

    console.log(this.state)
    console.log(this.props)

    return (
      <div>
        <div>
          <GridContainer justify="center">
            <GridItem xs={8}>
              <div style={{ width: "95%", margin: "0 auto", marginTop: "0px", marginBottom: "0px" }}>
                <Search style={{ color: "#bbb", marginBottom: "-8px", marginRight: "10px", fontSize: "1rem" }} className={classes.headerLinksSvg + " " + classes.searchIcon} />

                <CustomInput
                  formControlProps={{
                    className: classes.top + " " + classes.search,
                    style: { width: "85%", paddingTop: "10px" }
                  }}
                  id="query"
                  inputProps={{
                    placeholder: "Search...",
                    onChange: (event) => this.handleChange(event),
                    inputProps: {
                      "aria-label": "Search",
                      className: classes.searchInput
                    }
                  }}
                />

              </div>
            </GridItem>
            {(this.props.path == "haney-shippers") ?
              <GridItem xs={2}>
                <div className={classes.block}>
                  KSMS:
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.ksms}
                        onChange={this.handleSwitchChange("ksms")}
                        value="ksms"
                        classes={{
                          switchBase: classes.switchBase,
                          checked: classes.switchChecked,
                          icon: classes.switchIcon,
                          iconChecked: classes.switchIconChecked,
                          bar: classes.switchBar
                        }}
                      />
                    }
                    classes={{
                      label: classes.label
                    }}
                    style={{ marginLeft: "10px" }}
                  />
                </div>

              </GridItem>
              :
              <GridItem xs={2}>
                <div className={classes.block}>
                  TSA:
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.sta}
                        onChange={this.handleSwitchChange("sta")}
                        value="sta"
                        classes={{
                          switchBase: classes.switchBase,
                          checked: classes.switchChecked,
                          icon: classes.switchIcon,
                          iconChecked: classes.switchIconChecked,
                          bar: classes.switchBar
                        }}
                      />
                    }
                    classes={{
                      label: classes.label
                    }}
                    style={{ marginLeft: "10px" }}
                  />
                </div>

              </GridItem>
            }
            {this.props.path == "haney-shippers" ?
              <GridItem xs={2}>
                <Link to={`/shippers`}>
                  <GridOnIcon />
                </Link>
              </GridItem>
              :
              <GridItem xs={2}>
                <Link to={`/vendors`}>
                  <GridOnIcon />
                </Link>
              </GridItem>
            }
            <GridItem xs={12}>
              {this.props.AuthBool && (
                <ExploreMap uid={user.uid} query={this.state.query} path={path} ksms={this.state.ksms} sta={this.state.sta} />
              )}
            </GridItem>

          </GridContainer>
          {/* NEW CASE MODAL */}
          <Dialog
            open={this.state.newCaseModal}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => this.handleClose("newCaseModal")}
            aria-labelledby="shipment-modal-slide-title"
            aria-describedby="shipment-modal-slide-description"
          >

            <DialogContent
              id="shipment-modal-slide-description"
              className={classes.modalBody}
              style={{ paddingLeft: "0", paddingRight: "0", paddingTop: "0" }}
            >
              <Button
                style={{
                  margin: "0% 1% 0% 0%",
                  color: "black",
                }}
                simple
                className={classes.modalCloseButton}
                key="close"
                aria-label="Close"
                onClick={() => this.handleClose("newCaseModal")}
              >
                {" "}
                <Close className={classes.modalClose} />
              </Button>

              <CreateDocumentForm title={path} />

            </DialogContent>
          </Dialog>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  console.log(ownProps)
  return {
    AuthBool: !!state.auth.user,
    users: state.admin.users,
    user: state.auth.user,
    // cases: state.cases.cases,
    path: ownProps.match.params.id
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  console.log(this.props)
  return {
    startSetUsersList: dispatch(startSetUsersList()),
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(Style)
)(Explore);



// WEBPACK FOOTER //
// ./src/views/ExploreTemp/Explore.jsx